import { useDrawerUrlState } from 'hooks/ui/useDrawerUrlState';

const HOLDING_CLASS_DRAWER_CONFIG = {
  addHoldingClass: null,
  editHoldingClass: { holdingClassId: '' },
};

export function useHoldingClassDrawer() {
  return useDrawerUrlState(HOLDING_CLASS_DRAWER_CONFIG);
}
